import { render, staticRenderFns } from "./BaseFilterable.vue?vue&type=template&id=488d40e9&scoped=true"
import script from "./BaseFilterable.vue?vue&type=script&lang=ts"
export * from "./BaseFilterable.vue?vue&type=script&lang=ts"
import style0 from "./BaseFilterable.vue?vue&type=style&index=0&id=488d40e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d40e9",
  null
  
)

export default component.exports